import React from 'react';
import { Outlet } from 'react-router-dom';
import { BlogProvider } from './BlogContext';

const BlogLayout = () => {
  return (
    <BlogProvider>
      <Outlet />
    </BlogProvider>
  );
};

export default BlogLayout;